export default __webpack_public_path__ + "edb9846099eaaaab1c147a521872b222.png";